import {
  IsArray,
  IsInt,
  IsJSON,
  IsNumber,
  IsOptional,
  IsString,
  Validate,
  registerDecorator
} from 'class-validator';

export function IsStringOrStringArray() {
  return function (object: object, propertyName: string) {
    registerDecorator({
      name: 'isStringOrStringArray',
      target: object.constructor,
      propertyName: propertyName,
      validator: {
        validate(value: any) {
          return (
            typeof value === 'string' ||
            (Array.isArray(value) &&
              value.every((item) => typeof item === 'string'))
          );
        },
        defaultMessage() {
          return `${propertyName} must be a string or an array of strings`;
        }
      }
    });
  };
}

export class BoipaAuthorizationResponseDto {
  @IsString()
  result: string;

  @IsNumber()
  @IsOptional()
  merchantId?: number;

  @IsString()
  @IsOptional()
  merchantTxId?: string;

  @IsString()
  @IsOptional()
  redirectTarget?: string;

  @IsNumber()
  @IsOptional()
  txId?: number;

  @IsString()
  @IsOptional()
  acquirerTxId?: string;

  @IsNumber()
  @IsOptional()
  amount?: number;

  @IsString()
  @IsOptional()
  currency: string;

  @IsString()
  @IsOptional()
  customerId?: string;

  @IsString()
  @IsOptional()
  action?: string;

  @IsString()
  @IsOptional()
  pan?: string;

  @IsNumber()
  @IsOptional()
  brandId?: number;

  @IsNumber()
  @IsOptional()
  paymentSolutionId?: number;

  @IsString()
  @IsOptional()
  freeText?: string;

  @IsString()
  @IsOptional()
  language?: string;

  @IsNumber()
  @IsOptional()
  acquirerAmount?: number;

  @IsString()
  @IsOptional()
  acquirerCurrency?: string;

  @IsJSON()
  @IsOptional()
  paymentSolutionDetails?: object;

  @IsNumber()
  @IsOptional()
  rpId?: number;

  @IsString()
  @IsOptional()
  status?: string;

  @Validate(IsStringOrStringArray)
  @IsOptional()
  errors?: string | string[];

  @IsString()
  @IsOptional()
  resultId?: string;

  @IsInt()
  @IsOptional()
  processingTime?: number;

  @IsArray()
  @IsOptional()
  additionalDetails?: any[];

  @IsString()
  @IsOptional()
  merchantLandingPageRedirectMethod?: string;

  @IsString()
  @IsOptional()
  redirectionUrl?: string;
}
